export default __webpack_public_path__ + "videos/wow-gallery.mp4";